<block-ui>

  @if(showLoader) {
    <app-loading [text]="'Generating...'"></app-loading>
  } @else {
    <div class="container-fluid create-testcase p-3 pt-1 h-100">
      @if(!isGenerating) {
      
      <div class="d-flex mt-3" *ngIf="isEdit && viewType === 'summary'">
        <span class="flex-grow-1 user-guide v-center px-1"> Select the option to Analyze the Impacted Test Cases based on the Code Updates </span>
        <div class="d-flex">
          <button class="btn-accello-secondary btn-accello mx-2" [matMenuTriggerFor]="impactMenu">
            Impacted Test Cases
          </button>

          <mat-menu #impactMenu="matMenu">
            <button mat-menu-item (click)="handleTestCaseButtonClick('impacted')">
              Impacted
            </button>
            <button mat-menu-item (click)="handleTestCaseButtonClick('most-impacted')">
              Most Impacted
            </button>
          </mat-menu>

          <!-- <button
            class="btn-accello-primary"
            (click)="handleTestCaseButtonClick('most-impacted')">
            Most Impacted Test Cases
          </button> -->
        </div>
      </div>



      <div class="d-flex mb-2 mt-2 justify-content-end">
        <button
          [hidden]="isEdit"
          class="btn  btn-accello-primary btn-accello mx-2"
          (click)="onProceed()"
          [disabled]="!files.length || !form.valid || !mappingName"
        >
          Source Code Mappings
          <span *ngIf="isValidating"
            class="spinner-border spinner-border-sm mx-2"
            role="status"
            aria-hidden="true"
          ></span>
        </button>

        <button
          *ngIf="isEdit && viewType !== 'summary'"
          class="btn  btn-accello-primary btn-accello mx-2"
          [disabled]="isImpactedTestcasesUpdating"
          (click)="cancel()"
        >
          Cancel
        </button>
        <button
          *ngIf="isEdit && viewType !== 'summary'"
          class="btn  btn-accello-primary btn-accello mx-2"
          [disabled]="viewType === 'most-impacted' && !files.length"
        >
          Generate @if(isImpactedTestcasesUpdating) {
          <span
            class="spinner-border spinner-border-sm mx-2"
            role="status"
            aria-hidden="true"
          ></span>
          }
        </button>

      </div>


      <div class="card shadow-sm rounded card-cont overflow-hidden" [ngClass]="{ 'px-3': !isEdit }">
        <!-- MAPPING CREATION VIEW -->

        <div [ngClass]="{'mt-3': !isEdit}">

          <div *ngIf="isEdit" class="v-center top-header-banner p-2">
            <span>
              @if(viewType === 'summary') {
                Code Config Summary
              }
              @else if(viewType === 'impacted') {
                Impacted Test Cases
              }
              @else {
                Most Impacted Test Cases
              }
            </span>

          </div>

          @if(!isEdit){
            <div class="col-md-6">
              <div class="d-flex">
                <label class="form-label"> Mapping Name </label>
                <span
                  class="material-symbols-outlined mx-2 info-icon"
                  data-toggle="tooltip"
                  data-placement="top"
                  [title]="''"
                >
                  info
                </span>
              </div>
              <input
                type="text"
                placeholder="Enter mapping name"
                [(ngModel)]="mappingName"
                [disabled]="isEdit"
                class="form-control"
              />
            </div>

            <div class="col-md-6 mt-3">
              <app-file-upload
                [data]="fileUploadConfig"
                (filesSelected)="handleFilesSelected($event, data)"
                [viewOnly]="isEdit"
              ></app-file-upload>
            </div>
          }

          <form class="mt-3" [formGroup]="form" *ngIf="!isEdit">
            <formly-form
              [model]="model"
              [fields]="fields"
              [options]="options"
              [form]="form"
            ></formly-form>

            @if(viewType === 'most-impacted'){
            <div class="col-md-6 mt-3">
              <app-file-upload
                [data]="fileUploadConfigMostImpacted"
                (filesSelected)="handleFilesSelected($event, data)"
              ></app-file-upload>
            </div>
            }
          </form>

          <div class="p-3" *ngIf="isEdit">
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> Mapping Name </span>
              <span class="value-text no-act text-truncate"> {{ model.name }} </span>
            </div>
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> LLM </span>
              <span class="value-text no-act text-truncate"> {{ model.LLM }} </span>
            </div>
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> Vector Database </span>
              <span class="value-text no-act text-truncate"> {{ model.vectorDatabase }} </span>
            </div>
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> Vector Database API Key </span>
              <input class="value-text no-act text-truncate" type="password" [(ngModel)]="model.vectorStoreApiKey">
            </div>
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> GitHub Token </span>
              <input class="value-text no-act text-truncate" type="password" [(ngModel)]="model.githubToken">
            </div>
            <div class="inp-grp d-flex align-items-center">
              <span class="grp-title"> Git Repo Link </span>
              <input class="value-text no-act form-control" [(ngModel)]="model.githubLink">
            </div>
          </div>

          
        </div>
      </div>
      } @else {
      <div class="h-100 v-center w-50 mx-auto position-relative">
        <div class="mb-4">
          <app-progress-bar
            [text]="progressStatus.text"
            [progress]="progressStatus.percentage"
          ></app-progress-bar>
        </div>
        <div class="position-absolute top-55">
          <div *ngFor="let item of completionStatus" class="my-2">
            <img
              src="assets/images/tick-green.png"
              alt="tick"
              class="tick-icon"
            />
            <span class="mx-1 message-text-progress"> {{ item.message }} </span>
          </div>
        </div>
      </div>
      }
    </div>
  }
</block-ui>
